import { TranslationKey } from '@Localization';
import { observer } from 'mobx-react-lite';
import { PropsWithChildren, ReactElement } from 'react';
import { S_FieldError } from '../../design/errors/fieldError/S_FieldError';
import { S_Checkbox } from '../../design/inputs/checkbox/S_Checkbox';
import { handleChange } from '../helpers/formHelpers';

interface IValidatedCheckboxInputProps {
  id?: string;
  labelText?: string;
  checked?: boolean;
  onChange: () => void;
  isValid?: boolean;
  feedbacks?: TranslationKey[];
  className?: string;
  disabled?: boolean;
}

export const ValidatedCheckboxInput = observer((props: PropsWithChildren<IValidatedCheckboxInputProps>): ReactElement => {
  return (
    <div className='validated-checkbox-input'>
      <S_Checkbox
        id={props.id}
        disabled={props.disabled}
        checked={props.checked}
        valid={props.isValid === true}
        invalid={props.isValid === false}
        onChange={handleChange(props.onChange)}
        className={props.className}
        label={props.labelText || props.children}
      />
      {props.isValid === false && props.feedbacks && <S_FieldError feedbacks={props.feedbacks} />}
    </div>
  );
});
